import { render } from "./DesktopInvoiceSuccess.vue?vue&type=template&id=4562a042&scoped=true&ts=true"
import script from "./DesktopInvoiceSuccess.vue?vue&type=script&lang=ts"
export * from "./DesktopInvoiceSuccess.vue?vue&type=script&lang=ts"

import "./DesktopInvoiceSuccess.vue?vue&type=style&index=0&id=4562a042&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4562a042"]])

export default __exports__